import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createCoupon, editCoupon, showCoupon } from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { CouponProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Coupon() {
  return (
    <CouponProvider>
      <Switch>
        <Route
          exact
          path={createCoupon.spec}
          render={(props) => (
            <>
              <Can I="new" a="Coupon">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Coupon">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editCoupon.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Coupon">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Coupon">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showCoupon.spec}
          render={(props) => (
            <>
              <Can I="show" a="Coupon">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Coupon">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Coupon">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Coupon">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </CouponProvider>
  );
}
export default Coupon;
